import {queries} from '@/shared/integrations/zero'
import {Patient} from '@cypro/engine/schema'
import {useQuery} from '@rocicorp/zero/react'
import * as z from 'zod'

export function useGetPatient(id: string | undefined) {
  const {success: isUuid} = z.uuid().safeParse(id)
  const patientId = isUuid ? id : ''

  const [patient, meta] = useQuery(queries.patients.getPatientById(patientId || ''))

  return [patient as unknown as Patient, meta] as const
}
